module.exports = __webpack_public_path__ + "static/media/dashboard.a00d1dc1.png";